// @ts-nocheck
import { RootStoreType } from './RootStore';
import { flow, getRoot, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils/utils';
import { DutyAssignment } from './models/DutyAssignment';
import NotificationToast from '../components/common/NotificationToast';
import moment from 'moment';

export interface DutyAssignmentSearchCriteria {
  pharmacyApbNumberOrName?: string;
  pharmacyAddress?: string;
  startDate?: string;
  endDate?: string;
  date?: string;
  year?: string;
  pharmacyIdForNeighbor?: number;
  notAssigned?: boolean;
  publishedOnly?: boolean;
  planningId?: number;
  pharmacyId?: number;
  pharmacyIds?: number[];
  dutyAssignmentId?: number;
  type?: string;
  view?: string;
}

export const DutyAssignmentStore = types
  .compose(
    getBaseStore<Instance<typeof DutyAssignment>, SnapshotIn<typeof DutyAssignment>>(
      DutyAssignment,
      'dutyAssignmentId',
      'dutyAssignment',
    ),
    types.model('DutyAssignmentStore', {}),
  )
  .views((self) => ({
    getDutiesByType(pharmacyId: number, nightDuty: boolean) {
      if (pharmacyId > 0) {
        // const dutiesGrid = self.datas.forEach(da => {return da}); //.pharmacyId==pharmacyId && da.Duty.nightDuty == nightDuty)
        return self.datas;
      } else {
        return new Array();
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const root: RootStoreType = getRoot(self);
    const apiFetcher = env.api;

    const uploadDutiesOnGeowacht = flow(function*() {
      const result = yield env.api.get('dutyAssignment/uploadDutiesToGeowacht');
    });

    const assignDuty = flow(function* (data: any) {
      try {
        const result = yield env.api.post('dutyAssignment/Assign', data);
        if (result !== '' && result != null) {
          Array.from(result).map((item) => self.datas.put(item));
          NotificationToast.showSuccess('Duty assigned successfully');
        } else {
          NotificationToast.showError('Duty already assigned for this day and type');
        }
        return result;
      } catch (error) {
        console.log('error', error);
        NotificationToast.showError(
          // @ts-ignore
          error.error.errorMessage ? error.error.errorMessage : 'No DutyAssignment available for this date/type',
        );
        return null;
      }
    });

    const unassignDuty = flow(function* (data: any) {
      console.log(data);
      const result = yield env.api.post('dutyAssignment/Unassign/' + data, null);
      if (result != null) {
        NotificationToast.showSuccess('Duty unassigned successfully');
      } else {
        // NotificationToast.showError(
        //   error.error.errorMessage ? error.error.errorMessage : 'No DutyAssignment available for this date/type',
        // );
      }
    });

    const dutyRosterReport = flow(function* (criteria: any, lang: string, onSuccess?: () => void, onError?: () => void) {
      apiFetcher.downloadFile(
        'report/DutyRoster/' + lang,
        {
          params: criteria,
        },
        'pdf',
        'ListeDesGardes-du-' +
        moment(criteria.startDate).format('DD-MM-YYYY') +
        '-au-' +
        moment(criteria.endDate).format('DD-MM-YYYY'),
        onSuccess,
        onError,
      );
    });

    const searchAssignment = flow(function* (criteria: DutyAssignmentSearchCriteria) {
      const result = yield apiFetcher.get('dutyAssignment', {
        params: criteria,
      });
      // @ts-ignore
      self.putInStore(result);
      // @ts-ignore
      const resultIds = result.map((r) => r.dutyAssignmentId);
      return self.dataList.filter((d) => resultIds.indexOf(d.dutyAssignmentId) >= 0);
    });


    const searchAssignmentForPharmacies = flow(function* (criteria: DutyAssignmentSearchCriteria) {
      const result = yield apiFetcher.post('dutyAssignment/GetDutyAssignmentsForPharmacies', criteria);
      // @ts-ignore
      self.putInStore(result);
      // @ts-ignore
      const resultIds = result.map((r) => r.dutyAssignmentId);
      return self.dataList.filter((d) => resultIds.indexOf(d.dutyAssignmentId) >= 0);
    });

    const getMadiasanteResponse = flow(function*(startDate: string, endDate: string) {
      const res = yield env.api.get('dutyAssignment/mediasante/' + startDate + '/' + endDate, {});

      return res;
    });

    const searchAssignmentByPharmacyId = flow(function* (pharmacyId: number) {
      // const results = self.dataList.filter((d) => d.pharmacyId == pharmacyId);
      // if (results.length > 0) {
      //   return results;
      // }
      const result = yield apiFetcher.get('dutyAssignment', {
        params: { pharmacyId: pharmacyId },
      });

      // @ts-ignore
      self.putInStore(result);
      // @ts-ignore
      const resultIds = result.map((r) => r.dutyAssignmentId);
      return self.dataList.filter((d) => resultIds.indexOf(d.dutyAssignmentId) >= 0);
    });

    const verifyExclusion = flow(function* (data: any) {
      console.log(data);
      const result = yield env.api.post('dutyAssignment/VerifyExclusion', data);
      if (result != null && Array.isArray(result)) {
        return result;
      } else {
        return [] as string[];
      }
    });

    return {
      assignDuty,
      unassignDuty,
      dutyRosterReport,
      searchAssignment,
      searchAssignmentForPharmacies,
      searchAssignmentByPharmacyId,
      verifyExclusion,
      getMadiasanteResponse,
      uploadDutiesOnGeowacht
    };
  });
